'use client';

export function WizardExitThanksPopup() {
  return (
    <div className="rounded-lg text-white">
      <div className="absolute top-0 right-0">
        <svg width="497" height="181" viewBox="0 0 497 181" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_8976_51105)">
            <rect y="0.5" width="497" height="180" rx="8" fill="#002730" />
            <g opacity="0.8">
              <circle cx="527.562" cy="-32.4796" r="71.651" stroke="#64CCC5" strokeWidth="0.479271" />
              <circle opacity="0.8" cx="527.563" cy="-32.4798" r="95.6145" stroke="#64CCC5" strokeWidth="0.479271" />
              <circle opacity="0.7" cx="527.563" cy="-32.4801" r="119.578" stroke="#64CCC5" strokeWidth="0.479271" />
              <circle opacity="0.6" cx="527.562" cy="-32.4795" r="143.542" stroke="#64CCC5" strokeWidth="0.479271" />
              <circle opacity="0.5" cx="527.562" cy="-32.4798" r="167.505" stroke="#64CCC5" strokeWidth="0.479271" />
              <circle opacity="0.4" cx="527.562" cy="-32.4802" r="191.469" stroke="#64CCC5" strokeWidth="0.479271" />
              <circle opacity="0.3" cx="527.562" cy="-32.4804" r="215.432" stroke="#64CCC5" strokeWidth="0.479271" />
              <circle opacity="0.2" cx="527.563" cy="-32.4797" r="239.396" stroke="#64CCC5" strokeWidth="0.479271" />
              <circle opacity="0.15" cx="527.563" cy="-32.4801" r="263.359" stroke="#64CCC5" strokeWidth="0.479271" />
              <circle opacity="0.1" cx="527.562" cy="-32.4795" r="287.323" stroke="#64CCC5" strokeWidth="0.479271" />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_8976_51105">
              <rect y="0.5" width="497" height="180" rx="8" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="flex relative items-center">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 2.5C4.23858 2.5 2 4.73858 2 7.5V17.5C2 20.2614 4.23858 22.5 7 22.5H17C19.7614 22.5 22 20.2614 22 17.5V7.5C22 4.73858 19.7614 2.5 17 2.5H7ZM16.6402 8.7318C17.0645 9.08537 17.1218 9.71593 16.7682 10.1402L11.7682 16.1402C11.5937 16.3497 11.3411 16.4788 11.0691 16.4976C10.797 16.5165 10.5291 16.4234 10.3273 16.24L7.32733 13.5127C6.91868 13.1412 6.88856 12.5087 7.26007 12.1001C7.63157 11.6914 8.26402 11.6613 8.67268 12.0328L10.9002 14.0578L15.2318 8.85984C15.5854 8.43556 16.2159 8.37824 16.6402 8.7318Z"
            fill="#96E1DC"
          />
        </svg>
        <div className="text-2xl ml-2">Thanks for your feedback! </div>
      </div>
      <div className="mt-3 text-lg relative">
        We've noted your email address for future reference. Don't forget, you can use the code{' '}
        <strong style={{ color: 'rgba(150, 225, 220, 1)' }}>FUSEBASEWIZ</strong> for{' '}
        <strong style={{ color: 'rgba(150, 225, 220, 1)' }}>20% off</strong> your first month of FuseBase.
      </div>
    </div>
  );
}
